<template>
    <el-dialog
            title="支付明细"
            :visible.sync="DailogVisible"
            :before-close="handleClose"
            width="1280px"
            class="dialog-tips"
            style="margin-top: -10vh;"
            border>
            <p style="color:red;">{{errorMessage}}</p>
        <el-table :data="tableData" style="max-height:488px;overflow-y:auto">
            <el-table-column
                    prop="realName"
                    label="姓名"
                    header-align="center"
                    align="center"
            ></el-table-column>
            <el-table-column
                    prop="phone"
                    label="手机号"
                    header-align="center"
                    align="center"
            ></el-table-column>
            <el-table-column
                    prop="idCard"
                    label="证件号"
                    header-align="center"
                    align="center"
            ></el-table-column>
            <el-table-column
                    prop="bankNo"
                    label="收款账号"
                    header-align="center"
                    align="center"
            ></el-table-column>
            <el-table-column
                    prop="bankName"
                    label="开户行"
                    header-align="center"
                    align="center"
            ></el-table-column>
            <el-table-column
                    prop="unitPrice"
                    label="单价"
                    header-align="center"
                    align="center"
            ></el-table-column>
            <el-table-column
                    prop="quantity"
                    label="数量"
                    header-align="center"
                    align="center"
            ></el-table-column>
            <el-table-column
                    prop="dealMoney"
                    label="金额"
                    header-align="center"
                    align="center"
            ></el-table-column>
        </el-table>
        <div style="position:relative;margin-top:60px;">
        <el-pagination
                    :small="true"
                    background
                    :current-page="pageObject.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageObject.limit"
                    :total="pageObject.total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handlePageSize"
                    @current-change="handleCurrentPage">
            </el-pagination>
            </div>
        <div class="Payment-details" >

                <el-form label-width="214px" ref="form" :model="form" :inline="true" style="width: 512px;">

                    <el-form-item label="本次支付人次：">
                        <el-input style="border: 0px" v-model="form.peopleNum"  ></el-input>
                    </el-form-item>
                    <el-form-item label="自由职业者实收总额：">
                        <el-input style="border: 0px" v-model="form.money"  ></el-input>
                    </el-form-item>
                    <el-form-item label="平台综合服务费率（%）：">
                        <el-input style="border: 0" v-model="form.percentage"  ></el-input>
                    </el-form-item>
                    <el-form-item label="平台综合服务费(含6%增值税)：">
                        <el-input style="border: 0" v-model="form.serviceMoney"  ></el-input>
                    </el-form-item>

                </el-form>
        </div>
        <div style="width:100%;background:#ccc; font-weight: bold;font-size: 24px;overflow: hidden;padding:20px 0;">
                    <div style="float: right;margin-right:33px;width: 300px">
                       <p style="font-size:16px;">本次应付总额：<span style="display: inline-block;text-indent: 22px;font-size: 18px;">{{form.total}}</span></p>
                    </div>
        </div>
        <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="paymentOperation">支 付</el-button>
			</span>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                hasPayPass:'',
                pageObject:{
                    page : 1,
                    limit : 10,
                    total : 0,
                },
                dataList:[],
                form:{
                    peopleNum:'',
                    money:'',
                    percentage:'',
                    serviceMoney:"",
                    total:'',
                },
                payVisible : false,
            }
        },
        props: ['PaymentInfo','DailogVisible','errorMessage'],
        components: {},
        watch: {},
        computed: {
            tableData(){
                return this.dataList.map(item => {
                    return {
                        ...item,
                        unitPrice : item.unitPrice ? item.unitPrice.toFixed(2) : 0,
                        dealMoney : item.dealMoney ? item.dealMoney.toFixed(2) : 0,
                    }
                })
            },
        },
        methods: {
//            查询支付信息
            handleQueryInfo(){
                this.$http.get(`/sys/plat/deal/approval/getUserMoneyInformation?id=${this.PaymentInfo[0].id}&page=${this.pageObject.page}&limit=${this.pageObject.limit}`).then(({data:res})=>{
                    if(res.code == 0){
                        this.pageObject = {...this.pageObject,...res.data.pddList};
                        this.pageObject.total = Number(this.pageObject.total)
                        this.dataList = res.data.pddList.records;
                        this.form.peopleNum = res.data.listSize,
                        this.form.money = res.data.money.toFixed(2),
                        this.form.percentage = res.data.payFee,
                        this.form.serviceMoney = res.data.fee.toFixed(2),
                        this.form.total = res.data.total.toFixed(2)
                        this.hasPayPass = res.data.hasPayPass
                    }
                })
            },
            // 当前条数
            handlePageSize(val){
                console.log(val)
                this.pageObject.page = 1
                this.pageObject.limit = val
                this.handleQueryInfo()
            },
            //当前页数
            handleCurrentPage(val){
                this.pageObject.page = val
                this.handleQueryInfo()
            },
//关闭弹框
            handleClose(){
                console.log(1)
                this.$emit( 'handleClose',false)
            },
//支付操作
            paymentOperation(){
                if(this.hasPayPass == 0){
                    this.$emit('firstSetPassword')
                    return false;
                }
                let idSum = [];
                this.dataList.map((item)=>{
                    return idSum.push(item.id)
                })
                let params = {
                    total:this.form.total,
                    fiag:false,
                    IdSum:idSum
                }
                this.$emit( 'PaymentSubmit',params)
            }
        },
        created(){
            this.handleQueryInfo()
        }
    }
</script>
<style lang="scss" scoped>
    .Payment-details{
        margin-top: 50px;
        display: flex;
        justify-content: flex-end;
        /deep/ .el-input__inner{
            border: 0;
        }
    }
</style>